import {
    ActionTypes
} from "../type";

export const getInvestigationlist = (id) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.INVESTIGATION_DETAILS,
            payload: id
        })
    } catch (err) {
        throw (err)
    }
}